import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";
import EntryPublicSchema from "@common/schema/entry/public";
import * as Section from "@repoflow/components/section";
import { today } from "components/day/dates";
import * as ViewRoute from "./view";
import * as NewRoute from "./new";

// The food log, one day at a time. `/day` alone is today, resolved HERE in the
// browser — see components/day/dates for why the server never decides which
// day it is — and redirected to its own address so that a reload, a bookmark
// and the Back button all mean the same day.
const LocalProvider = ({
  match: {
    params,
  },
  children: Children,
}) => {
  const base = `/day`;
  const basepath = `/day`;

  return (
    <Section.Provider
      schema={EntryPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider, and
          routes.test.js, which scans this directory for both halves. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

const Today = () => <Redirect to={`/day/${today()}`} />;

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/:date/new`} component={NewRoute.Content} />
          <Route path={`${basepath}/:date`} component={ViewRoute.Content} />
          <Route path={`${basepath}/`} component={Today} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Food log</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/:date/new`} component={NewRoute.Indice} />
            <Route path={`${basepath}/:date`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
